import { render, staticRenderFns } from "./SystemConfigurations.vue?vue&type=template&id=16e47048"
import script from "./SystemConfigurations.vue?vue&type=script&lang=js"
export * from "./SystemConfigurations.vue?vue&type=script&lang=js"
import style0 from "./SystemConfigurations.vue?vue&type=style&index=0&id=16e47048&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports